import { FormControl, FormLabel } from "@mui/material"
import React from "react"

const FormItem = ({ label, children, normalWidth }) => {
  return (
    <FormControl fullWidth={!normalWidth} margin="dense">
      <FormLabel>{label}</FormLabel>
      {children}
    </FormControl>
  )
}

export default FormItem
